export * from './FAQCommon';
export * from './FAQContainer';
export * from './FAQHeader';
export * from './FAQList';
export * from './FAQItem';
export * from './faqData';
export { default as FAQ } from './FAQ';
